import { Component, OnInit, Output,Input, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { Global } from 'src/app/shared/global';

@Component({
  selector: 'app-medicare',
  templateUrl: './medicare.component.html',
  styleUrls: ['./medicare.component.scss']
})
export class MedicareComponent implements OnInit {
  @Output() buttonSelectEvent = new EventEmitter<any>();
  @Input() title: string = '';
  @Input() source: string = 'medicare';
  constructor(private router: Router, private global: Global) { }

  ngOnInit(): void {
  }
  // nextPage() {
    
  // }
  // back(): void {
  //   this.router.navigate(['/lesson-categories'], { queryParams: { org: this.global.orgID } });
  // }

  returnedSectionTitle(data){
    this.title = data;
  }
}
